import { render, staticRenderFns } from "./SpotPriceRequests.vue?vue&type=template&id=2c329f55&"
import script from "./SpotPriceRequests.vue?vue&type=script&lang=js&"
export * from "./SpotPriceRequests.vue?vue&type=script&lang=js&"
import style0 from "./SpotPriceRequests.vue?vue&type=style&index=0&id=2c329f55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports